import envConfig from '@app/enviroment/enviroment';
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
// Log.setLogger(console);
// Log.setLevel(Log.DEBUG);
const KEYCLOAK_CLIENT_ID = envConfig.getEnvKey('KEYCLOAK_CLIENT_ID');
const KEYCLOAK_URL = envConfig.getEnvKey('KEYCLOAK_URL');
const KEYCLOAK_REALM = envConfig.getEnvKey('KEYCLOAK_REALM');

const oidcConfig: UserManagerSettings = {
  authority: `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}`,
  client_id: KEYCLOAK_CLIENT_ID as string,
  redirect_uri: window.location.origin + '/auth/callback',
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email offline_access',

  /**
   * Silent renewal configuration
   * Use token refresh instead of iframe session monitoring
   */
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/auth/silent-renew.html',
  accessTokenExpiringNotificationTimeInSeconds: 60, // Start renewal 60 seconds before expiry

  /**
   *  Session monitoring
   *  DISABLED: Keycloak session iframe check causes 'login_required' errors
   *  and triggers unwanted logout events. Use token refresh instead.
   */
  monitorSession: false,
  // checkSessionIntervalInSeconds: 10,

  // Additional settings for reliability
  filterProtocolClaims: true, // Filter out protocol claims from the user object

  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
};

export default oidcConfig;
